module.exports = __webpack_public_path__ + "img/zw2.1d8d9efa.webp";